var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0672 9.49369H25.2803V8.70681C25.2803 8.27187 24.9284 7.91992 24.4935 7.91992C24.0585 7.91992 23.7066 8.27187 23.7066 8.70681V9.49369H22.9197C22.4848 9.49369 22.1328 9.84564 22.1328 10.2806C22.1328 10.7155 22.4848 11.0675 22.9197 11.0675H23.7066V11.8543C23.7066 12.2893 24.0585 12.6412 24.4935 12.6412C24.9284 12.6412 25.2803 12.2893 25.2803 11.8543V11.0675H26.0672C26.5022 11.0675 26.8541 10.7155 26.8541 10.2806C26.8541 9.84564 26.5022 9.49369 26.0672 9.49369Z",
    fill: "url(#paint0_linear_740_6156)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8767 6.34721C23.3113 6.34721 23.6636 5.99491 23.6636 5.56032C23.6636 5.12574 23.3113 4.77344 22.8767 4.77344C22.4421 4.77344 22.0898 5.12574 22.0898 5.56032C22.0898 5.99491 22.4421 6.34721 22.8767 6.34721Z",
    fill: "url(#paint1_linear_740_6156)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7205 11.0679C20.1551 11.0679 20.5074 10.7156 20.5074 10.281C20.5074 9.84644 20.1551 9.49414 19.7205 9.49414C19.2859 9.49414 18.9336 9.84644 18.9336 10.281C18.9336 10.7156 19.2859 11.0679 19.7205 11.0679Z",
    fill: "url(#paint2_linear_740_6156)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8711 19.1682C13.1785 18.8608 13.6765 18.8608 13.9838 19.1682L14.2144 19.3987V12.6426H12.6406V19.3987L12.8711 19.1682Z",
    fill: "url(#paint3_linear_740_6156)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.294 12.6426H15.7858V21.2983C15.7858 21.6164 15.5945 21.9038 15.3002 22.0252C15.2026 22.0659 15.1004 22.0851 14.999 22.0851C14.7946 22.0851 14.5932 22.0052 14.4426 21.8546L13.4252 20.8371L12.4078 21.8546C12.1818 22.0805 11.8453 22.1473 11.5502 22.0252C11.2559 21.9038 11.0645 21.6164 11.0645 21.2983V12.6426H10.6233L4.76953 16.0223V26.072C4.76953 26.5069 5.12148 26.8589 5.55641 26.8589H21.294C21.7289 26.8589 22.0809 26.5069 22.0809 26.072V13.4295C22.0809 12.9945 21.7289 12.6426 21.294 12.6426Z",
    fill: "url(#paint4_linear_740_6156)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4492 4.82312L17.8756 2.09737C17.7711 1.91681 17.5989 1.78461 17.3976 1.73084C17.1971 1.67781 16.9811 1.70551 16.8005 1.80922L14.3797 3.20692C14.3816 2.65789 14.2514 2.06254 13.9696 1.57467C13.5492 0.846181 12.8707 0.325214 12.0585 0.107721C11.2478 -0.108199 10.3986 0.00243649 9.67018 0.422001C8.66125 1.00524 8.05803 2.09102 8.09795 3.25597L8.10335 3.42195C8.10335 3.42809 8.10335 3.43349 8.10414 3.43963L8.18099 5.76386L6.2407 4.55485C6.23991 4.55406 6.23839 4.55333 6.23761 4.55254L6.09623 4.46415C5.10649 3.84865 3.86621 3.82557 2.85576 4.4088C2.12726 4.82915 1.6063 5.50765 1.3888 6.31992C1.17131 7.13219 1.28278 7.9805 1.70308 8.70899C1.99029 9.20552 2.39459 9.59156 2.85948 9.85831L0.393611 11.2518C0.0171675 11.4692 -0.111723 11.9504 0.10556 12.3268L1.73152 15.0528C1.9488 15.4291 2.43 15.5581 2.80644 15.3408L19.1613 5.89805C19.5376 5.68082 19.6665 5.19956 19.4492 4.82312ZM5.21545 8.49801C4.46325 8.93063 3.49942 8.67343 3.06622 7.92217C2.63207 7.17065 2.89101 6.20546 3.64253 5.7721C4.14739 5.47933 4.76908 5.4916 5.26319 5.79974L7.48754 7.18617L5.21545 8.49801ZM12.7639 3.60813C12.6557 4.01348 12.3954 4.35283 12.0316 4.56261L9.75884 5.87481L9.67018 3.20215C9.65098 2.61892 9.95299 2.07639 10.4571 1.78514C10.8198 1.57383 11.2439 1.51928 11.6512 1.6276C12.0569 1.73672 12.3966 1.99723 12.6064 2.36145C12.817 2.72577 12.873 3.20163 12.7639 3.60813Z",
    fill: "url(#paint5_linear_740_6156)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_740_6156",
    x1: 23.2252,
    y1: 10.5893,
    x2: 26.8202,
    y2: 10.5884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_740_6156",
    x1: 22.454,
    y1: 5.66323,
    x2: 23.6523,
    y2: 5.66294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_740_6156",
    x1: 19.2977,
    y1: 10.3839,
    x2: 20.4961,
    y2: 10.3836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_740_6156",
    x1: 13.0047,
    y1: 16.4624,
    x2: 14.2031,
    y2: 16.4624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_740_6156",
    x1: 8.77482,
    y1: 20.6803,
    x2: 21.9565,
    y2: 20.6765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_740_6156",
    x1: 4.52435,
    y1: 8.73321,
    x2: 19.4142,
    y2: 8.72869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.d6699962f26f2881c725c515eaac2259.svg";
export { ForwardRef as ReactComponent };